import React, { useState, useEffect } from "react";
import styles from "./MoreTravellersMain.module.css";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { useHistory, Link, useParams } from "react-router-dom";
import { ApplicationByIdApi } from "../../../config/ApplicationByIdApi";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";
import changeDetails from "../../../store/Actions/DetailsAction";

function MoreTravellersMain(props) {
  const [loading, setLoading] = useState(true);
  let { id } = useParams();
  const history = useHistory()

  const [submitted ,setSubmitted] = useState([])
  const [notSubmitted,setNotSubmitted] = useState([])
  const [allData, setAllData] = useState([])

  const [count, setCount] = useState(0)

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      const application = async (token) => {
        const getApplication = await ApplicationByIdApi(token, id);

        if (getApplication.data) {
          console.log(getApplication.data.data);
          if (getApplication.data.data.status !== "CANCELLED") {
            if (getApplication.data.data.payment_status === "UNPAID") {
              toast.error(
                <span style={{ display: "flex", alignItems: "center" }}>
                  <BiError size="30" style={{ marginRight: "10px" }} />
                  Kindly Pay First!
                </span>,
                {
                  position: "bottom-left",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                }
              );
              setTimeout(() => {
                history.push(`/dashboard/transactions/payment/${id}`);
              }, 2000);
            } else {
                setCount(getApplication.data.data.travellers_count)
                setLoading(false);
                for (let i = 0; i < (getApplication.data.data.travellers_count); i++) {
                    setAllData(allData => [...allData, i])
                }
                for (let i = 0; i < (getApplication.data.data.travellers_count - getApplication.data.data.travellers_informations.length); i++) {
                    setNotSubmitted(notSubmitted => [...notSubmitted, i+getApplication.data.data.travellers_informations.length])
                }
                for (let i = 0; i < (getApplication.data.data.travellers_informations.length); i++) {
                    setSubmitted(submitted => [...submitted, i])
                }
              props.ChangePassportDetails({
                id: id,
                application: true,
              })
              props.ChangeDetails({
                total: 0,
                embassy_fees: 0,
                normal_fees: 0,
                express_fees: 0,
              });
            }
          } else {
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                This Application Was Cancelled!
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
            setTimeout(() => {
              history.push("/dashboard/my-applications");
            }, 2000);
          }
        } else if (getApplication.error) {
          console.log(getApplication.error);

          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              Invalid Application!
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setTimeout(() => {
            history.push("/dashboard/my-applications");
          }, 2000);
        }
      };
      application(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  return (
    <div>
      <h1 className={styles.head}>Travellers</h1>
      {loading ? (
        <div className={styles.loader}>
          <div className="spinner-border" role="status"></div>
        </div>
      ) : (
        <div className={styles.mainBox}>
              {submitted.map((value, index)=>(
                <div className={styles.eachBox}>
                <h1 className={styles.eachHead}>Traveller {value+1}: </h1>
                <button  className={styles.eachFilled}> <BsCheckAll size={24} />  Application Submitted</button>
              </div>
            ))}
            {notSubmitted.map((value, index)=>(
                <div className={styles.eachBox}>
                <h1 className={styles.eachHead}>Traveller {value+1}: </h1>
                <Link to={`/dashboard/my-applications/${id}/upload-passport`}>
                <button className={styles.eachFill}>Fill Application</button>
                </Link>
              </div>
            ))}
          
        </div>
      )}
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) =>
    dispatch(changePassportDetails(passportDetails)),
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(MoreTravellersMain);